module.exports = __webpack_public_path__ + "img/logout.2340ef98.svg";